import { inject } from '@angular/core';
import { withCallStatus } from '@ngrx-traits/signals';
import {
  patchState,
  signalStoreFeature,
  withMethods,
  withProps,
  withState,
} from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { User } from '@seatix/shared/domain';
import { catchError, EMPTY, pipe, switchMap, tap } from 'rxjs';
import { AuthApiService } from '../auth-api/auth-api.service';

export function withProfileUpdate() {
  return signalStoreFeature(
    withState<{ profileUpdatedData: Partial<User> | null }>({
      profileUpdatedData: null,
    }),
    withCallStatus({
      collection: 'profileUpdate',
      errorType: 'string',
    }),
    withProps(() => ({
      _authApiService: inject(AuthApiService),
    })),
    withMethods((store) => {
      const authApiService = store._authApiService;
      const updateProfile = rxMethod<Partial<User>>(
        pipe(
          switchMap((user) => {
            store.isProfileUpdateLoading();

            return authApiService.patchUser(user).pipe(
              tap((response) => {
                store.setProfileUpdateLoaded();
                const { first_name, last_name, phone } = response.data;
                patchState(store, {
                  profileUpdatedData: {
                    first_name,
                    last_name,
                    phone,
                  },
                });
              }),
              catchError(() => {
                const errorMessage = 'Ocurrió un error al actualizar el perfil';
                store.setProfileUpdateError(errorMessage);
                return EMPTY;
              }),
            );
          }),
        ),
      );

      return {
        updateProfile,
      };
    }),
  );
}
